export default __webpack_public_path__ + "static/media/Headdress of the Earth Mother.5afe2684.jpg";